import { useState } from "react";
import classnames from "classnames";
import * as Commons from "oc-commons/Commons";

import { Auswahl } from "../Auswahl";

export function TorMontageplattenOptionen({ tor }) {
  const [, forceUpdate] = useState<Record<string, never>>();

  return (
    <div id="TorOptionen">
      <div className="scrollarea" role="region" aria-label={I18N("aria::Tor-Montageoptionen")}>
        <TorMontageOptionen tor={tor} />
      </div>

      <div className="footer">
        <button
          className={classnames(
            "tor-ist-fertig-checkbox checkbox-button primary-button",
            tor.torIstFertig ? "checked" : ""
          )}
          role="checkbox"
          aria-checked={tor.torIstFertig}
          onClick={async () => {
            tor.torIstFertig = !tor.torIstFertig;
            APP.logUserAction(
              { action: "torIstFertigCheckbox", value: tor.torIstFertig },
              { stateChange: false }
            );
            forceUpdate({});
            await Commons.sleep(2000);
            if (tor.torIstFertig) {
              APP.arrangement.setSelectedObjects(null);
            }
          }}
        >
          {tor.torIstFertig
            ? I18N("das Tor ist fertig konfiguriert")
            : I18N("bitte klicken Sie hier, wenn das Tor fertig konfiguriert ist")}
        </button>
      </div>
    </div>
  );
}

export function TorMontageOptionen({ tor }) {
  const wandMontagePlatten = tor.getWandmontagePlatten();

  return (
    <Auswahl
      Key="Anschlagprofilfarbe"
      title={I18N("Anschlagprofilfarbe")}
      value={
        wandMontagePlatten?.[0].anschlagprofilfarbeAuswahlwert ??
        APP.arrangement.anschlagprofilfarbeAuswahlwert
      }
      onChange={(v) => {
        wandMontagePlatten.forEach((p) => (p.anschlagprofilfarbeAuswahlwert = v));
        APP.dirty();
      }}
    />
  );
}
